module.exports = require('lodash').delay